import { FilterApplyButtonClickEventArgs as FilterApplyButtonClickEventArgs_internal } from "./FilterApplyButtonClickEventArgs";
var IgrFilterApplyButtonClickEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrFilterApplyButtonClickEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrFilterApplyButtonClickEventArgs.prototype.createImplementation = function () {
        return new FilterApplyButtonClickEventArgs_internal();
    };
    Object.defineProperty(IgrFilterApplyButtonClickEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrFilterApplyButtonClickEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrFilterApplyButtonClickEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrFilterApplyButtonClickEventArgs;
}());
export { IgrFilterApplyButtonClickEventArgs };
//# sourceMappingURL=igr-filter-apply-button-click-event-args.js.map
